module.exports = __webpack_public_path__ + "img/fav_null.dbb660ad.png";